import {
  createChangelog,
  deleteChangelog,
  listChangelog,
  updateChangelog,
  type ChangelogCreate,
  type ChangelogInDb,
  type ChangelogListResult,
  type ChangelogUpdate,
} from '@/api';

/**
 * Fetch changelog entries, newest first. `result_count` in the response is
 * the total matching the given filter (so a `since` query counts only the
 * entries after that timestamp, not the global total).
 */
export async function fetchChangelogs(query: {
  since?: string;
  limit?: number;
  offset?: number;
}): Promise<ChangelogListResult | null> {
  const response = await listChangelog({ query });
  return response.data ?? null;
}

export async function createChangelogEntry(body: ChangelogCreate): Promise<ChangelogInDb | null> {
  const response = await createChangelog({ body });
  return response.data ?? null;
}

export async function updateChangelogEntry(
  uid: string,
  body: ChangelogUpdate
): Promise<ChangelogInDb | null> {
  const response = await updateChangelog({ path: { uid }, body });
  return response.data ?? null;
}

export async function deleteChangelogEntry(uid: string): Promise<boolean> {
  const response = await deleteChangelog({ path: { uid } });
  return !response.error;
}
